export default __webpack_public_path__ + "static/media/6popup.6596f345.jpg";